var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-popup",
    {
      attrs: { active: _vm.isActive, title: "" },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: _vm.close,
      },
    },
    [
      _vm.modalData
        ? _c("div", { staticClass: "details-popup" }, [
            _c(
              "button",
              { staticClass: "popup-close", on: { click: _vm.close } },
              [_vm._v("✕")]
            ),
            _c("div", { staticClass: "details-hero" }, [
              _c("div", { staticClass: "details-hero-left" }, [
                _c("span", { staticClass: "closure-badge" }, [
                  _vm._v("Cierre #" + _vm._s(_vm.modalData.closure_number)),
                ]),
                _c("div", { staticClass: "company-name" }, [
                  _vm._v(_vm._s(_vm.companyName)),
                ]),
                _vm.companyLegalName
                  ? _c("div", { staticClass: "company-meta" }, [
                      _c("span", { staticClass: "company-meta-label" }, [
                        _vm._v("Razón Social"),
                      ]),
                      _c("span", { staticClass: "company-legal" }, [
                        _vm._v(_vm._s(_vm.companyLegalName)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.modalData.responsible_agency
                  ? _c("div", { staticClass: "company-meta" }, [
                      _c("span", { staticClass: "company-meta-label" }, [
                        _vm._v("Agencia Responsable"),
                      ]),
                      _c("span", { staticClass: "company-legal" }, [
                        _vm._v(_vm._s(_vm.modalData.responsible_agency.name)),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "campaign-ref" }, [
                  _vm._v(
                    "\n          Campaña ID " +
                      _vm._s(_vm.modalData.campaign_id) +
                      "\n          "
                  ),
                  _vm.modalData.campaign_name
                    ? _c("span", [
                        _vm._v(" — " + _vm._s(_vm.modalData.campaign_name)),
                      ])
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "campaign-type-badge",
                      class: {
                        "campaign-type-badge--unknown":
                          !_vm.modalData.campaign_type,
                      },
                    },
                    [
                      _c("span", { staticClass: "campaign-type-prefix" }, [
                        _vm._v("Tipo ·"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.campaignTypeLabel)),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "details-hero-right" },
                [
                  _c("div", { staticClass: "amount-display" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatAmount(
                          _vm.chargeTotal,
                          _vm.modalData.currency
                        )
                      )
                    ),
                  ]),
                  _c(
                    "vs-chip",
                    {
                      staticClass: "status-badge",
                      attrs: { color: _vm.chargeStatusColor, textWhite: "" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.chargeStatusLabel) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-card info-card--span3" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("Período")]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.modalData.date_from)) +
                      " → " +
                      _vm._s(_vm.formatDate(_vm.modalData.date_to))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-card info-card--span3" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v("Fecha Vencimiento Cobro"),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.modalData.collection_due_date))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-card info-card--span2" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v("Días Faltantes"),
                ]),
                _c(
                  "span",
                  {
                    class: [
                      "info-value",
                      _vm.daysUntilCollection.includes("vencido")
                        ? "text-danger"
                        : _vm.daysUntilCollection === "Hoy"
                        ? "text-warning"
                        : "",
                    ],
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.daysUntilCollection) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "info-card info-card--span2" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v("Plazo Facturación"),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.modalData.charge_term) + " días"),
                ]),
              ]),
              _c("div", { staticClass: "info-card info-card--span2" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v("Plazo de Pago"),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.modalData.payment_term) + " días"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modes-strip" }, [
              _c("div", { staticClass: "mode-item" }, [
                _c("span", { staticClass: "mode-label" }, [
                  _vm._v("Facturación"),
                ]),
                _c("span", { staticClass: "mode-value" }, [
                  _vm._v(_vm._s(_vm.billingModeLabel)),
                ]),
              ]),
              _c("span", { staticClass: "mode-sep" }, [_vm._v("·")]),
              _c("div", { staticClass: "mode-item" }, [
                _c("span", { staticClass: "mode-label" }, [_vm._v("Pago")]),
                _c("span", { staticClass: "mode-value" }, [
                  _vm._v(_vm._s(_vm.paymentModeLabel)),
                ]),
              ]),
              _c("span", { staticClass: "mode-sep" }, [_vm._v("·")]),
              _c("div", { staticClass: "mode-item" }, [
                _c("span", { staticClass: "mode-label" }, [_vm._v("Comisión")]),
                _c("span", { staticClass: "mode-value" }, [
                  _vm._v(_vm._s(_vm.commissionModeLabel)),
                ]),
              ]),
            ]),
            _vm.modalData.billing_status
              ? _c(
                  "div",
                  { staticClass: "billing-status-bar" },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "FileTextIcon", svgClasses: "w-4 h-4" },
                    }),
                    _c("span", [_vm._v("Facturación:")]),
                    _c(
                      "vs-chip",
                      {
                        attrs: {
                          color: _vm.billingStatusColor,
                          textWhite: "",
                          size: "small",
                        },
                      },
                      [_vm._v(_vm._s(_vm.billingStatusLabel))]
                    ),
                    _vm.modalData.billing
                      ? _c("span", { staticClass: "billing-by" }, [
                          _vm._v(
                            "\n        — " +
                              _vm._s(
                                _vm.formatUserName(
                                  _vm.modalData.billing.created_by
                                )
                              ) +
                              ", " +
                              _vm._s(
                                _vm.formatDateTime(
                                  _vm.modalData.billing.created_at
                                )
                              ) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.isCollected && _vm.modalData.charge
              ? _c(
                  "div",
                  { staticClass: "billed-info" },
                  [
                    _c("feather-icon", {
                      attrs: {
                        icon: "CheckCircleIcon",
                        svgClasses: "w-4 h-4 text-success",
                      },
                    }),
                    _c("span", [
                      _vm._v("Cobrado por "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatUserName(_vm.modalData.charge.created_by)
                          )
                        ),
                      ]),
                      _vm._v(
                        " el " +
                          _vm._s(
                            _vm.formatDateTime(_vm.modalData.charge.created_at)
                          )
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.modalData.charge && _vm.modalData.charge.canceled_at
              ? _c(
                  "div",
                  { staticClass: "canceled-info" },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "XCircleIcon", svgClasses: "w-4 h-4" },
                    }),
                    _c("span", [
                      _vm._v("Anulado por "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.formatUserName(_vm.modalData.charge.canceled_by)
                          )
                        ),
                      ]),
                      _vm._v(
                        " el " +
                          _vm._s(
                            _vm.formatDateTime(_vm.modalData.charge.canceled_at)
                          )
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm.modalData.summary
              ? _c("div", { staticClass: "summary-section" }, [
                  _c("div", { staticClass: "summary-title" }, [
                    _vm._v("Resumen financiero"),
                  ]),
                  _c("div", { staticClass: "summary-grid" }, [
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("Total a Cobrar"),
                      ]),
                      _c("span", { staticClass: "summary-value primary" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatAmount(
                              _vm.modalData.summary.billing_amount,
                              _vm.modalData.currency
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("Comisión Agencia"),
                      ]),
                      _c("div", { staticClass: "summary-value-row" }, [
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatAmount(
                                _vm.modalData.summary.agency_commission_payment,
                                _vm.modalData.currency
                              )
                            )
                          ),
                        ]),
                        _vm.modalData.agency_commission_percentage
                          ? _c("span", { staticClass: "summary-pct" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.modalData.agency_commission_percentage
                                ) + "%"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("Comisión Exchange"),
                      ]),
                      _c("div", { staticClass: "summary-value-row" }, [
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatAmount(
                                _vm.modalData.summary
                                  .exchange_commission_payment,
                                _vm.modalData.currency
                              )
                            )
                          ),
                        ]),
                        _vm.modalData.exchange_commission_percentage
                          ? _c("span", { staticClass: "summary-pct" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.modalData.exchange_commission_percentage
                                ) + "%"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("Impuesto Internacional"),
                      ]),
                      _c("div", { staticClass: "summary-value-row" }, [
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatAmount(
                                _vm.modalData.summary.international_tax_payment,
                                _vm.modalData.currency
                              )
                            )
                          ),
                        ]),
                        _vm.modalData.international_tax_percentage
                          ? _c("span", { staticClass: "summary-pct" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.modalData.international_tax_percentage
                                ) + "%"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.modalData.created_by
              ? _c(
                  "div",
                  { staticClass: "created-by-info" },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "UserIcon", svgClasses: "w-3 h-3" },
                    }),
                    _c("span", [
                      _vm._v("Creado por "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.formatUserName(_vm.modalData.created_by))
                        ),
                      ]),
                      _vm._v(
                        " el " +
                          _vm._s(_vm.formatDateTime(_vm.modalData.created_at))
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }